// extracted by mini-css-extract-plugin
export var content = "_sk-1";
export var wrapper = "_sk-0";